export const BREADCRUMB_INTEGRACAO = [{ link: '', label: 'Integração' }];
